import { action, makeObservable, observable } from 'mobx'

import { IRecurringWorkflowSettings } from '~/client/graph'
import * as e from '~/client/src/shared/stores/EventStore/eventConstants'

import RecurringWorkflowSettings from '../../models/RecurringWorkflowSettings'
import { customDebounce } from '../../utils/util'
import EventsStore from '../EventStore/Events.store'
import GraphExecutorStore from './GraphExecutor.store'

const FETCH_DEBOUNCE_TIME = 300

export default class RecurringWorkflowSettingsStore {
  @observable private byIdMap = new Map<string, RecurringWorkflowSettings>()

  public constructor(
    private readonly eventsStore: EventsStore,
    private readonly graphExecutorStore: GraphExecutorStore,
  ) {
    makeObservable(this)

    this.loadRecurringSetting = customDebounce(
      this.loadRecurringSetting,
      FETCH_DEBOUNCE_TIME,
    )
    this.subscribeToSettings = customDebounce(
      this.subscribeToSettings,
      FETCH_DEBOUNCE_TIME,
    )
    this.unsubscribeFromSettings = customDebounce(
      this.unsubscribeFromSettings,
      FETCH_DEBOUNCE_TIME,
    )
  }

  public loadRecurringSetting = (id: string, callbackFn?: () => void) => {
    if (!id || this.byIdMap.has(id)) {
      return
    }

    this.eventsStore.dispatch(e.GET_RECURRING_WORKFLOW_SETTINGS, id, callbackFn)
  }

  public subscribeToSettings = () => {
    this.eventsStore.dispatch(e.LISTEN_TO_RECURRING_WORKFLOW_SETTINGS)
  }

  public unsubscribeFromSettings = () => {
    this.graphExecutorStore.terminateSubscription(
      e.LISTEN_TO_RECURRING_WORKFLOW_SETTINGS,
    )
  }

  public getById = (id: string): RecurringWorkflowSettings => {
    if (this.byIdMap.has(id)) {
      return this.byIdMap.get(id)
    }
  }

  @action.bound
  public receiveOne(id: string, dto: IRecurringWorkflowSettings) {
    if (dto) {
      this.byIdMap.set(id, RecurringWorkflowSettings.fromDto(dto))
    } else {
      this.byIdMap.delete(id)
    }
  }

  @action.bound
  public clearData() {
    this.byIdMap.clear()
  }
}
